import {NotificationType} from './notificationType'

export class NotificationMessage {
    public message: string;
    public fallback: string;
    public key: string;
    public inlineMessage: string;
    public type: NotificationType;
}